import { render, staticRenderFns } from "./circleWavyWarningIcon.vue?vue&type=template&id=6ef528e2&"
import script from "./circleWavyWarningIcon.vue?vue&type=script&lang=js&"
export * from "./circleWavyWarningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports